import {initCKEditor, insertAtSelection} from "../../../helpers/inputs/ckeditor/ckeditor";
import Axios from "axios";
import {handleAjaxSuccess} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../helpers/loading";

function initClientEmailBaseTemplateIndex() {
	const editorElement = document.querySelector('#settings-email-base-template .editor');
	let editor;

	initCKEditor(editorElement).then(newEditor => {
		// Save editor reference
		editor = newEditor

		// Set editor value
		editor.setData(window['settings']['emailBaseTemplate']);

		// Remove loading overlay
		editorElement.parentElement.classList.remove('loading');
	});

	// Init buttons
	const saveButton = document.querySelector('.save-base-email-template-button')
	saveButton.addEventListener('click', saveBaseEmailTemplate)

	// Init placeholders
	document.querySelectorAll('#settings-email-base-template .placeholder-trigger').forEach(trigger => {
		trigger.addEventListener('click', () => {
			insertAtSelection(editor, trigger.dataset.placeholder);
		})
	});

	/**
	 * Methods
	 */
	function saveBaseEmailTemplate() {
		const data = editor.getData();

		loading();
		Axios.post(
			window['routes/client.settings.emails.store-base-email-template-setting'],
			{
				template: data,
			}
		)
			.then(response => {
				handleAjaxSuccess(response, () => {
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)

	}
}


export {initClientEmailBaseTemplateIndex}
